<template>
    <div class="page" style="background-color: hsla(0, 0%, 98%, 1)">

        <!-- <div class="player bgCover" style="background-image: url('voiceCourse/player_bg.png')"> -->
        <div class="player bgCover" style="background:#fff;">
            <div class="" style="height: 44px;">
                <div class="nav fixedTop">
                    <div @click="back()" class="nav_back">
                        <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
                    </div>
                    <div class="nav_title"> {{player.currentItem ? player.currentItem.title : ''}}</div>
                    <div @click="share()" class="nav_share"></div>
                </div>
            </div>
            <div class="inner paddingH16" style="padding-bottom:16px;">
                <!-- <div class="coverArea centered bgCover" style="width: 263px; height: 274px;
                    background: url('voiceCourse/cover_image_bg.png') no-repeat"> -->
                <div class="coverArea centered bgCover" style="width: 210px;">
                    <div class="imageBox alignCenter" style="padding-top: 44px;">
                        <img class="block centered bgC1C1C1" :src="player.currentItem ? player.currentItem.coverImg : ''"
                             style="width: 124px; height: 124px; border-radius: 8px;box-shadow: 4px 4px 30px #C1CBD1;"/>
                        <div class="grey20 font18r bold" style="
                        margin-top: 31px;
                        box-sizing: border-box;
                        justify-content: space-between;
                        align-items: center;
                        font-size: 18px;

                        font-weight: 600;
                        ">
                            {{player.currentItem ? player.currentItem.title : ''}}
                        </div>
                    </div>
                </div>
                <div class="flexLayout " style="margin-top: 41px;">
                    <div class="flexItem">
                         <a class="block grey60" @click="show()">
                            <i class="icon synopsisIcon"></i>
                             <div style="margin-left:6px;" class="heartTitle">
                                简介
                            </div>
                        </a>
                    </div>
                     <div style="flex:2;" class="flexItem alignCenter grey60 relative">
                         <i class="heartIcon" :class="{active : player.currentItem ? player.currentItem.isPraise : false}"
                            @click="praise()"></i>
                        <div class="heartTitle" :class="{active : player.currentItem ? player.currentItem.isPraise : false}">
                            点赞
                        </div>
                    </div>
                    <div style="flex:2;" class="flexItem alignCenter grey60 relative">
                       <a class="block grey60" @click="scrollToCommentArea()">
                            <i class="icon commentIcon"></i>
                            <sup class="font10r" style="position:absolute;right:25px;padding:0 5px;background:#FF4843;color:#fff;border-radius:7px;">
                                {{player.currentItem ? player.currentItem.commentCount : ''}}
                            </sup>
                            <div class="heartTitle">
                                学习心得
                            </div>
                        </a>
                    </div>
                    <div class="flexItem alignRight">
                        <i class="icon playlistIcon" @click="$refs.playlistDrawer.open()"></i>
                        <div style="margin-right:4px;"  class="heartTitle">
                            列表
                        </div>
                    </div>
                </div>

                <div style="margin-top:32px;" class=" progress relative" @click="onClickProgress">
                    <div class="bar" :style="'width:' + player.progress + '%;'"></div>
                    <div class="point circle" :style="'left:' + player.progress + '%;'">
                    </div>
                    <div class="bar-timer">
                        <div>{{player.currentPosition}}</div>
                        <div>{{player.totalLength}}</div>
                    </div>
                </div>

                <div class="flexLayout" style="margin-top: 30px;">
                    <div class="flexItem alignC" style="padding-top: 8px;">
                        <i class="icon prevButton" @click="prev()"></i>
                    </div>
                    <div class="flexItem alignC">
                        <i class="icon playButton" @click="play()" v-show="!player.playStatus"></i>
                        <i class="icon pauseButton" @click="pause()" v-show="player.playStatus"></i>
                    </div>
                    <div class="flexItem alignC" style="padding-top: 8px;">
                        <i class="icon nextButton" @click="next()"></i>
                    </div>
                </div><!-- end player control buttons -->

                <div class="topicArea" style="margin-top: 30px;height:79px;border-radius:6px;background: #F5F5F5;display:flex;align-items:center;">
                    <div class="inner flexLayout" style="padding:0 8px;width:100%;">
                        <div style="width: 51px;">
                            <img class="roundBorder4" width="51" height="51"
                                 :src="player.currentItem && player.currentItem.albumInfo ? player.currentItem.albumInfo.coverImg : ''"/>
                        </div>
                        <div class="flexItem" style="padding-left: 8px;">
                            <div class="font12r bold" style="color: hsla(230, 12%, 20%, 1)">
                                {{player.currentItem && player.currentItem.albumInfo ? player.currentItem.albumInfo.title : ''}}
                            </div>
                            <div  style="margin-top:20px" class="font10r grey60">
                                <!-- {{player.currentItem.albumInfo}} -->
                                已更新{{player.currentItem ? player.currentItem.updateCount : ''}}本/共{{player.currentItem && player.currentItem.albumInfo ? player.currentItem.albumInfo.segCount : ''}}节
                            </div>
                        </div>
                        <div @click="getAlbum(player.currentItem && player.currentItem.albumInfo ? player.currentItem.albumInfo.id : '')" class="font12r" style="position:relative; padding-top: 20px;padding-right:30px;">
                            <span style="color:#5B616C;">进入组合</span>
                            <img style="position:absolute;top:23px;right:16px;width:11px;height:11px;" src="icon/learnIcon/more.svg" alt="">
                            <span class="angleBracketsFont"></span>
                        </div>
                    </div>
                </div><!-- end .topicArea -->

                <div class="marginT24 bgF5F5F5 paddingV12 alignC font13r roundBorder4" style="color: #5B616C;">
                    更多精彩听书
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAkElEQVQokaWSMQ7CMAxFXY7TDU5CGWiJo4INqECcgITEgpByaxR1CAOwO/D3p6dnGeDv5Vx1vZ8WMUhDbUiS3V7mRaBleSBJ6jk0AFDpjXzeI8mIHA4xxokaXHFYGpIR2V+LjC2d7kiSW+tmZaa13FSmb5Mld1Q1va/nnmbnFzoDDbXZ+NSxaxQFn/3yEdq9AObmOCIjZfs5AAAAAElFTkSuQmCC" width="6" height="6" alt=""/>
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAkElEQVQokaWSMQ7CMAxFXY7TDU5CGWiJo4INqECcgITEgpByaxR1CAOwO/D3p6dnGeDv5Vx1vZ8WMUhDbUiS3V7mRaBleSBJ6jk0AFDpjXzeI8mIHA4xxokaXHFYGpIR2V+LjC2d7kiSW+tmZaa13FSmb5Mld1Q1va/nnmbnFzoDDbXZ+NSxaxQFn/3yEdq9AObmOCIjZfs5AAAAAElFTkSuQmCC" width="6" height="6" alt=""/>
                </div>

            </div><!-- end .inner -->
        </div><!-- end .player -->

        <!-- 章节简介 -->
        <!-- <div class="marginT12 paddingV12 paddingH16 white_bg">
            <header class="fWeight600" style="color: hsla(230, 12%, 20%, 1); line-height: 1.6875em; letter-spacing: 0.28px;">
                <img src="voiceCourse/book_icon.svg" width="18" height="18"/>
                章节简介
            </header>
            默认显示50字
            <div class="marginT8 paddingH8 paddingV12 clearfix bubbleText concise font12r fWeight400"
                 style="color: rgba(86, 91, 113, 1); line-height: 1.833em">
                <template v-if="!introduction.showAll">
                    <template v-if="player.currentItem && player.currentItem.introduction">
                        {{player.currentItem.introduction.length > 50 ? player.currentItem.introduction.substr(0, 50) : player.currentItem.introduction || '<暂无简介>'}}
                    </template>
                </template>
                <template v-else>{{player.currentItem ? player.currentItem.introduction || '' : ''}}</template>
                <span class="link fr" style="font-size: 116.7%; color: rgba(29, 113, 198, 1);"
                    @click="introduction.showAll=!introduction.showAll">
                    <template v-if="!introduction.showAll">展开</template>
                    <template v-if="introduction.showAll">收起</template>
                </span>
            </div>
        </div> -->

        <!-- 最新推荐 -->
        <!-- <div class="marginT12">
            <voiceCourseModule ref="voiceCourseModule" title="最新推荐"
               layout="horizontalCardLayout"/>
        </div> -->

        <!-- 最近推荐 -->
<!--        <div class="marginT12 nearest-recommend">-->
<!--            <div class="nearest-title">最近推荐</div>-->
<!--            <div class="nearest-content hiddenScrollbar">-->
<!--                <div :style="{'width': (102+14)*dataList.length + 'px'}">-->
<!--                    <div @click="viewItem(item)" class="nearest-item" v-for="(item , index) in dataList" :key="index">-->
<!--                        <div class="choiceness-img">-->
<!--                            <img width="102" height="102" class=" cover item-img" :src="item.coverImg" alt="精选图片">-->
<!--                            <div class="choiceness-title">-->
<!--                                <img class="play-icon" src="icon/learnIcon/choiceness-play.svg" alt="精选播放图标">-->
<!--                                <span class="IitenIn">{{item.pv||0}}人收听</span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <h3>{{item.title}}</h3>-->
<!--                        <div class="parameter">-->
<!--                            <span class="update">更新{{item.updateCount || 0}}本</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->
<!--        </div>-->

        <div class="marginT12 paddingV16 generalPagePaddingH white_bg">
            <adModule :type="adTypeEnum.VOICE_DETAIL_PAGE.code" version="4"/>
        </div>

        <div class="marginT12 paddingV16 generalPagePaddingH white_bg">
            <recommendInfoList :infoList="dataItem ? dataItem.interactionList : []"/>
        </div>

        <!-- 最新评论 -->
        <div class="marginT12 white_bg" id="commentArea">

            <div class="inner padding16">
                <!-- 评论标题 -->
                <div class="comment-title">
                    <span>学习心得</span><span class="comment-sum">({{player.currentItem ? player.currentItem.commentCount : ''}})</span>
                </div>
                <commentList ref="commentList"/>

                <!-- 我也要发表评论 -->
                <div style="margin-top: 30px; ">
                    <a href="javascript:;" @click="$refs.commentEditingDrawer.open()">
                        <img class="block centered" src="voiceCourse/edit_comment_button.png"
                             style="width: 100%; max-width: 345px; height: 35px"/>
                    </a>
                </div>

            </div><!-- end .inner -->
        </div><!-- end 最新评论 -->

        <div class="font12r grey60 alignCenter" style="padding: 26px 0 9px;">
            -没有更多啦-
        </div>
<!--
        <a class="fixedBackIcon" href="javascript:;" @click="back()">
            <img class="icon" src="icon/back_icon.svg"/>
        </a>
        <a class="fixedShareIcon" href="javascript:;" @click="share()">
            <img class="icon" src="icon/white_circle_share_icon.svg"/>
        </a> -->

        <commentEditingDrawer ref="commentEditingDrawer" :submitApiConfig="commentApiConfig"
            :id="dataItem ? dataItem.id : ''" :onSubmitSuccess="onSubmitCommentSuccess"/>

        <playlistDrawer ref="playlistDrawer" :playlist="player.playlist" :currentIndex="player.currentPlayIndex"
            :onSwitchItem="switchItem"/>

        <!-- 简介抽屉 -->
        <div class="synopsis-drawer" v-show="synopsisShow">
            <div @click="clock()" style="position:absoult;top:0;width:100%;height:100%;background:#000;opacity: .5;">

            </div>
            <div class="synopsis-main">
                 <div class="synopsis-title">
                    <i class="synopsis-icon"></i>
                    <span>课程简介</span>
                </div>
                <div class="synopsis-content">
                     {{player.currentItem && player.currentItem.introduction !== null ? player.currentItem.introduction : '<暂无简介>'}}
                    <!-- 本课程是幼师必学五本书中的第一本书，以幼儿心理
                    学为切入点，讲解如何从幼儿心理角度去了解孩子在
                    成长以及学习中的心里状态和变化。 -->
                </div>
                <div style="width:100%;height:8px;background: #F5F5F5;">
                </div>
                <div @click="clock()" style="
                    width:100%;
                    height:56px;
                    text-align:center;
                    line-height:56px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #1B1B1B;">
                    关闭
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import moment from 'moment';

// modules
import voiceCourseModule from './voiceCourseModule';
import commentEditingDrawer from '@comp/drawer/commentEditingDrawer';
import playlistDrawer from '@comp/drawer/voiceCoursePlaylistDrawer';
import commentList from './commentList';
import adModule from '@comp/ad/bannerModule2'
import recommendInfoList from '@comp/contentModule/recommendInfoList';

// platformApi
import requestManager from '@comp/platformApi/requestManager';
import consoleApi from '@comp/platformApi/consoleApi';

// data
import bizTypeEnum from '@data/bizTypeEnum';
import adTypeEnum from '@/components/ad/adTypeEnum';
import browsingBizTypeEnum from '@data/browsingBizTypeEnum';

// api
import audioApi from '@comp/voiceCourse/audioApi';
import praiseApi from '@api/praise';
import browsingApi from '@api/browsing';

// config
import appConfig from '../../appConfig';

// utils
import consoleHelper from '@util/consoleHelper';
import domHelper from '@util/domHelper';
import objectHelper from '@util/objectHelper';
import audioHelper  from '@util/audioHelper';
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import windowHelper from '@util/windowHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';
import routeHelper from "@util/routeHelper";

const config = {
    apiConfig : {
        get : {
            url : 'portal/api/audio/info',
            dataColumnMapping : {
                media : 'audioUrl'
            }
        },
        list:{
            url:'portal/api/audio/latest',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        }
    },
    commentApiConfig : {
        url : 'portal/audio/comment/addComment',
        method : 'post'
    }
};

export default {
    name: "voiceCourseDetail",
    extends : shixunPagePart,
    components : {
        voiceCourseModule, commentEditingDrawer, playlistDrawer, commentList,
        adModule, recommendInfoList
    },
    data () {
        return {
            title : '语音课程',
            pageKey: 'listen-details',
            adTypeEnum : adTypeEnum,
            enableDataList : true,
            enableDataItem : true,
            autoLoadDataList : true,
            scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,
            commentApiConfig : config.commentApiConfig,
            synopsisShow:false,
            introduction : {
                showAll : false
            },
            player : {
                tab : 'voice',
                playStatus : false,
                currentPlayIndex : 0,
                playlist : [],
                currentItem : null,
                // @var Number
                currentTime : 0,
                // var String
                currentPosition : '00:00',
                // var Number
                progressRatio : 0,
                // var Number
                totalSeconds : 0,
                // var String
                totalLength : '00:00',
            },
            playControl : null,
            albumData : null,
            listenStartTime : null,
            listenEndTime : null,
        }
    },
    methods : {
        //简介抽屉关闭
        clock(){
            this.synopsisShow = false;
        },

        //简介抽屉显示
        show(){
            this.synopsisShow = true;
        },



        //进入专题
        getAlbum(id){
            this.$router.push({name:'albumID',params: {id:id}})
        },

        viewItem : function (dataItem) {
            appHelper.redirect('/voiceCourse/detail/' + dataItem.id);
        },

        loadAlbum(albumId) {

            consoleApi.time('loadAlbum');
            requestManager.request(audioApi.albumInfo(albumId), (error, result) => {

                consoleApi.timeEnd('loadAlbum');

                if (error)
                {
                    appHelper.showHint('出错了！');
                    consoleHelper.logError(error);
                    return;
                }

                if (result.errorCode)
                {
                    appHelper.showHint(result.errorCode + ': ' + result.msg);
                    consoleHelper.logError(result.errorCode + ': ' + result.msg);
                    return;
                }

                this.albumData = result.data;
                this.albumData.audioSeg = objectHelper.listDataColumnConvert(this.albumData.audioSeg, this.apiConfig.get.dataColumnMapping);
                this.addList(this.albumData.audioSeg);
            });
        },

        onLoadDataList() {

            const id            = routeHelper.getParam(this, 'id') || '';
            const promotionCode = routeHelper.getParam(this, 'promotionCode') || '';

            if (promotionCode)
            {
                appHelper.recordSharedBrowse({
                    promotionCode : promotionCode,
                    id : id,
                    bizType: 'AUDIO_SEG',
                });
            }

            // audio id
            if (id)
            {
                this.loadDataItem(id);
            }
        },

        onLoadDataItem() {

            this.playItem(this.dataItem);

            if (this.dataItem.albumInfo)
            {
                this.loadAlbum(this.dataItem.albumInfo.id);
            }

            this.$refs.commentList.updateDataList({
                segId : this.dataItem.id
            });

            appHelper.setTitle(this.dataItem.title);

            this.setWechatShare({
                title   : appHelper.getTitle(),
                desc    : this.player.currentItem.introduction || appConfig.desc,
                // link    : appHelper.generateShareUrl('/voiceCourse/detail/' + this.player.currentItem.id),
                imgUrl  : appHelper.getAppIcon(), // 分享图标
                type: 'music', // 分享类型,music、video或link，不填默认为link
            });

        },
        back() {
             appHelper.back(this)
        },
        // setWechatShare : function() {
        //
        //     if (!this.player.currentItem)
        //     {
        //         return;
        //     }
        //
        //     let wechatShareOptions = {
        //         // title   : this.player.currentItem.title,
        //         title   : appHelper.getTitle(),
        //         desc    : this.player.currentItem.introduction || appConfig.desc,
        //         link    : appHelper.generateShareUrl('/voiceCourse/detail/' + this.player.currentItem.id),
        //         imgUrl  : appHelper.getAppIcon(), // 分享图标
        //         type: 'music', // 分享类型,music、video或link，不填默认为link
        //     };
        //
        //     wechatHelper.setShare(wechatShareOptions);
        // },

        /**
         * format time length to mm:ss text
         * @param   Number duration (seconds)
         * @return  String
         */
        formatDuration : function (duration) {

            let second = duration % 60;
            let minute = Math.floor(duration / 60);
            let result = '';
            result += (minute >= 10 ? minute : '0' + minute);
            result += ':';
            result += (second >= 10 ? second : '0' + second);

            return result;
        },
        formatTimeLength : function (seconds){
            let someday = new Date('2000-01-01 00:00:00');
            let timestamp = someday.getTime() + seconds * 1000;
            return moment(timestamp).format('mm:ss');
        },
        play : function (){
            this.playControl.play();
            this.listenStartTime = new Date().getTime();

            // update playing status
            this.player.playStatus = this.playControl.getStatus();
        },
        pause : function (){
            this.playControl.pause();
            // this.submitEndLog();

            // update playing status
            this.player.playStatus = this.playControl.getStatus();

            this.submitListenRecord();
            this.listenStartTime = null;
            this.listenEndTime = null;
        },
        stop : function (){
            this.playControl.stop();

            // update playing status
            this.player.playStatus = this.playControl.getStatus();

            this.submitListenRecord();
            this.listenStartTime = null;
            this.listenEndTime = null;
        },
        prev : function (){
            consoleHelper.logDebug('prev segment.');
            if (!this.player.playlist.length)
            {
                return;
            }

            this.player.currentPlayIndex == 0 ?
                this.player.currentPlayIndex = this.player.playlist.length - 1 :
                this.player.currentPlayIndex--;

            if (this.player.playStatus)
            {
                this.submitListenRecord();
            }
            this.listenStartTime = new Date().getTime();

            this.player.currentItem = this.player.playlist[this.player.currentPlayIndex];
            this.outputSignal({
                type : 'changeVoice',
                data : this.player.currentItem
            });

            if (this.player.playStatus)
            {
                this.playControl.setAudio(this.player.currentItem.media);
                this.updatePlayStatus();
                this.listenStartTime = new Date().getTime();
                this.listenEndTime = null;
            }
        },
        next : function (){
            consoleHelper.logDebug('next segment.');
            if (!this.player.playlist.length)
            {
                return;
            }

            this.player.currentPlayIndex + 1 >= this.player.playlist.length ?
                this.player.currentPlayIndex = 0 :
                this.player.currentPlayIndex++;

            if (this.player.playStatus)
            {
                this.submitListenRecord();
            }
            this.listenStartTime = new Date().getTime();

            this.player.currentItem = this.player.playlist[this.player.currentPlayIndex];

            // this.updateUrl();
            this.setWechatShare();

            this.outputSignal({
                type : 'changeVoice',
                data : this.player.currentItem
            });

            if (this.player.playStatus)
            {
                this.playControl.setAudio(this.player.currentItem.media);
                this.updatePlayStatus();
                this.listenStartTime = new Date().getTime();
                this.listenEndTime = null;
            }

            this.$forceUpdate();
        },
        getItem : function (id) {
            for (let i=0; i<this.player.playlist.length; i++)
            {
                if (typeof(this.player.playlist[i].id) != 'undefined' && this.player.playlist[i].id == id)
                {
                    return this.player.playlist[i];
                }
            }

            return null;
        },
        /**
         * @param   Object  item
         */
        getIndexByItem : function (item) {

            const id = item.id;
            for (let i=0; i<this.player.playlist.length; i++)
            {
                if (typeof(this.player.playlist[i].id) != 'undefined' && this.player.playlist[i].id == id)
                {
                    return i;
                }
            }

            return -1;
        },

        // 直接添加，不考虑重复项目
        addItem : function (item) {
            if (this.getIndexByItem(item) >= 0)
            {
                return;
            }
            this.player.playlist.push(item);
        },
        // 循环调用 addItem
        addList : function (list) {
            for (let i=0; i<list.length; i++)
            {
                this.addItem(list[i]);
            }
        },
        // 先添加后播放
        playItem : function (item)
        {
            for(let i = 0;i < this.player.playlist.length; i++){
                if(item.id === this.player.playlist[i].id){
                    this.player.playlist.splice(i,1)
                    // consoleHelper.log('object');
                }
            }
            this.addItem(item);

            this.player.currentItem = item;
            this.player.currentPlayIndex = this.getIndexByItem(item);
            // this.updateUrl();
            this.setWechatShare();

            consoleHelper.log('currentPlayIndex= ' + this.player.currentPlayIndex);

            this.playControl.setAudio(this.player.currentItem.media);
            this.updatePlayStatus();

            this.listenStartTime = new Date().getTime();

            this.outputSignal({
                type : 'changeVoice',
                data : this.player.currentItem
            });
            // this.loadCommentList(item.id);
            consoleHelper.log(this.player);
        },
        switchItem : function (item) {

            // submit listen record
            this.submitListenRecord();
            this.player.currentItem = item;
            this.playControl.setAudio(item.media);
            this.updatePlayStatus();
            this.listenStartTime = new Date().getTime();
            this.listenEndTime = null;

            // this.updateUrl();
            this.setWechatShare();

            this.outputSignal({
                type : 'changeVoice',
                data : this.player.currentItem
            });
            this.player.currentPlayIndex = this.getIndexByItem(item);
            // this.loadCommentList(item.id);
        },
        updatePlayStatus : function () {
            this.player.playStatus = this.playControl.getStatus();
        },
        // 先添加后播放
        playList : function (list) {

            if (!list.length)
            {
                return;
            }

            // 播放位置
            let listLength = this.player.playlist.length;

            this.addList(list);

            // play first item
            this.switchItem(this.player.playlist[listLength]);
        },
        updateProgress() {

            let currentIntegerTime = parseInt(this.player.currentTime);
            // debugger;
            this.player.currentPosition = this.formatDuration(currentIntegerTime);

            if (this.player.totalSeconds == 0)
            {
                this.player.progress = 0;
            }
            else
            {
                this.player.progress = currentIntegerTime / this.player.totalSeconds * 100;
            }

            // this.$forceUpdate();
        },
        /**
         * @param   Number  currentTime
         */
        setCurrentTime(currentTime) {
            this.player.currentTime = currentTime;
            this.updateProgress();
        },
        onClickProgress(event) {
            let ratio = domHelper.getProgressClickPosition(event);
            let newCurrentTime = this.player.totalSeconds * ratio;
            this.playControl.setCurrentTime(newCurrentTime);
            // this.setCurrentTime(newCurrentTime);
        },
        initPlayControl : function () {
            let audioPlayer = audioHelper.createAudioPlayer();
            audioPlayer.el.style.display = 'hidden';
            this.$el.appendChild(audioPlayer.el);
            this.playControl = audioPlayer;
            // window.audioPlayer = audioPlayer;

            const me = this;
            audioPlayer.init({
                loadedmetadata : function (event) {

                    // get audio total length (seconds)
                    let duration = parseInt(this.duration);
                    //
                    consoleHelper.logDebug('loadedmetadata event: duration=' + duration);
                    //
                    let totalSeconds = me.player.totalSeconds = parseInt(duration); // || parseInt(this.duration);
                    consoleHelper.logDebug('totalSeconds=' + totalSeconds);
                    //
                    me.player.totalLength = me.formatDuration(totalSeconds);    // mm:ss expression
                    //
                    this.muted = false;
                    this.volume = 1;
                },
                timeupdate : function (event) {

                    // this: audio element
                    consoleHelper.logDebug(event);
                    // @type Number  currentTime (seconds)
                    me.player.currentTime = this.currentTime;
                    consoleHelper.logDebug('currentTime: ' + this.currentTime);

                    me.updateProgress();
                },
                ended : function () {
                    // next audio
                    me.next();
                },
                onPlay : function () {
                    consoleHelper.logDebug('playing.');
                },
                error : function (event) {
                    let target = event.currentTarget;
                    let error = target.error;
                    consoleHelper.logError('[error] audio error: ' + error.code + ' ' + error.message);
                    consoleHelper.logDebug(event);
                }

            });
        },
        onSubmitCommentSuccess(data) {
            this.$refs.commentList.dataList.push(data);
        },
        loadVoiceItemData(options = {}, callback) {
            options.url = config.apiConfig.get.url;
            options.method = config.apiConfig.get.method || 'get';
            requestManager.request(options, callback);
        },
        scrollToCommentArea() {
            // get #commentArea element' offset top by document
            let commentArea = document.getElementById('commentArea');
            let top = commentArea.offsetTop;
            windowHelper.scrollTo(top);
        },
        praise: function () {
            let params = {
                id: this.dataItem.id,
                bizType: bizTypeEnum.AUDIO_SEG.code
            };

            const me = this;
            let callback = function () {
                me.dataItem.isPraise = !me.dataItem.isPraise;
                if (me.dataItem.isPraise) {
                    me.dataItem.praise++;
                } else {
                    me.dataItem.praise--;
                }
            };

            if ( !this.dataItem.isPraise )
            {
                praiseApi.praise(params, (result) => {
                    appHelper.showHint(result.data);
                    callback();
                });
            }
            else
            {
                praiseApi.cancelPraise(params, (result) => {
                    appHelper.showHint(result.data);
                    callback();
                });
            }
        },
        submitListenRecord() {

            if (!this.player.currentItem)
            {
                consoleHelper.log('current item is empty.');
                return;
            }

            this.listenEndTime = new Date().getTime();

            let options = objectHelper.clone(browsingApi.recordAdd);
            options.data = {
                // bizId : this.player.currentItem.id,
                browsingBizId : this.player.currentItem.id,
                browsingBizType : browsingBizTypeEnum.AUDIO_SEGMENT.code,
                startTime : this.listenStartTime,
                endTime : this.listenEndTime,
            };
            requestManager.request(options, (error, result) => {
                if (error)
                {
                    return;
                }
            });
        },
        share() {
            appHelper.shareAlert();
        }
    },
    watch: {

        $route(to, from) {

            // 同页面不同参数需要使用函数加载新数据
            if (to.name === from.name)
            {
                const id = to.params.id || '';
                this.$route.params.id = id;

                this.dataItem = {};
                this.loadDataItem(id);
                window.scrollTo(0,0);
            }
            // this.$router.go(0)  // 安卓下会刷新页面，微信下会回到旧地址，苹果下无法跳转
        }
    },
    mounted() {

        this.initPlayControl();

        // check temp voice list
        let voiceList = window.tempVoiceList || [];

        const me = this;
        if (voiceList)
        {
            voiceList = objectHelper.listDataColumnConvert(voiceList, config.apiConfig.get.dataColumnMapping || {});
            // this.playList(voiceList);

            let dataPath = config.apiConfig.get.dataPath || 'data';
            let dataColumnMapping = config.apiConfig.get.dataColumnMapping || {};

            for (let i=0; i<voiceList.length; i++)
            {
                this.loadVoiceItemData({
                    params : {
                        id : voiceList[i].id
                    }
                }, (error, result) => {
                    if (error)
                    {
                        consoleHelper.error(error);
                        return;
                    }
                    let data = objectHelper.getDataByKeyPath(result, dataPath);
                    if (!data)
                    {
                        consoleHelper.error('data not found.');
                        return;
                    }

                    data = objectHelper.dataColumnConvert(data, dataColumnMapping);
                    me.addItem(data);
                    if (me.player.playlist.length == 1)
                    {
                        me.player.currentPlayIndex = 0;
                        me.playItem(me.player.playlist[0]);
                    }
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>

//返回，分享导航
.nav{
    width: 100%;
    height: 44px;
    background: #fff;
    height: 44px;
    display: flex;
    padding: 0 4%;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    .nav_back{
        width: 22px;
        height: 22px;
    }

    .nav_title{

        font-size: 20px;

        font-weight: 500;
        // line-height: 28px;

        color: #2C2C2C;
        width: 240px;
        text-align: center;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;

    }
    .nav_share{
        width: 22px;
        height: 22px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url(data:image/png;base64,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);
    }
}

//评论列表标题
.comment-title{

    font-size: 18px;

    font-weight: 500;
    // line-height: 31px;
    color: #34353C;
    .comment-sum{
        margin-left: 2px;
        font-size: 14px;

        font-weight: 400;
        // line-height: 24px;
        color: #5B616C;
    }
}

//简介弹框

.synopsis-drawer{
    width: 100%;
    height: 100%;
    // height: 250px;
    // background: #FFA724;
    // background: #ccc;
    // padding: 12px 18px ;
    // box-sizing: border-box;

    // border-radius: 16px 16px 0px 0px;
    position: fixed;
    bottom: 0;
    z-index: 999;
    .synopsis-main{
        width: 100%;
        background: #fff;
        padding: 12px 18px ;
        box-sizing: border-box;

        border-radius: 16px 16px 0px 0px;
        position: absolute;
        bottom: 0;


    }



    .synopsis-title{
        margin-bottom: 17px;
        .synopsis-icon{
            display: inline-block;
            width: 24px;
            height: 24px;
            background-repeat: no-repeat;
            vertical-align: middle;
            background-size: 100% 100%;
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADY0lEQVRoQ+1YTUwTQRT+3nYFjEQSg0oE4patgAkHPaAcOGiiiZ70ZFogMSQePGjiwYPeOJDo1ahnDT8tId6sNxK96YGDRk1QoDQBFJMeTCQRYplnZtruNqXtbilhrdnNXtp989775pv3ZuYj1PhDNZ4/fABeM+gz4DNQ5Qz4S6jKCax6uCMDHD3WDKq/AgTaXEVjTgI0SwMLnwvteardhKjrB9AGIt3RH/Ma9M04XVtZLWVbFgDHjLNgPQ5Cs2Ow7QbvQFs3Kbz0gaeDXUhrT0B0YQd+1gERpkjiVbGxJQHwCHR0mfMADLAcSuot/zDA0k4OUMZpQIyC6R6ABmu8+uzgzHKhfKawmT5Bw8mfhfFLAxgze7CPPoI5FywF8Hp5ACSZalQ29jj5Q73qkYkzb4Cw5uBL+mm2/AhxkQYTM+4BxELnALxWgSVMTp+kgeScIwfRjn5AewzCqYxtNvnMjM9BiNvFEtlWL08PN+JQ0y/rf8HDNLj4fOcAkA5SJJl0AqBSVsEPvgWox7bnJPh3Lw18S7nxofzEQjnegL0EoIJPmmFoFLOWAIk7FE48yiXPMbMdJA6VBcOB954woACMmyHoNG8tQeA8RRbeqG9j5hHUaWccmWB+6R2AmGEA+lJRAFMdnUCg0weQa9bFZoILu1AFRZwpQJ8BuV/4NWBvZP4Symujfhey207pw5zfhfw26nEbnWhtQ2D/sn0vEL0UScyqTa4WijizG3eMA9oQmGfwdfEyjcgbWg0BKHVYqxkG/l8A02YIQuv+p4/T5ZJTWpN2oK9mAahCjgaPQqOm8ldK7YtnNzLH2XVhsLuXepE+TYNJ+5LtIoFqTPiZ0YIG/fvOGbCErXL3tiIpMlLQxGi+AmEpEVHzOggPAWpxDS6nS1UsbFnSIhkZWc1RV8zmlLVlMQHtzwiFlxd5MngcmnYXoFsV+VLqnnRLKWxUKC2qQpsw+hDQ5bXOvbhrB80AUjIiNWR/ZPN3Oxlq1Dq2RISGEvFirDl6Ui0P9VdBgVZH2pmlbH7DSjbHmgSVLw4zT4HIUabElvgBbMZpaHWlVGxHAI5JFxhw1LwE0ANbG8034AVA3KfI0otK/e4ZALtgjW5wQG5WcvmloPGn3Gl0t5JX1bGbzrzw5QPwYtbzY/oMeM3AX3W/kk/Byl52AAAAAElFTkSuQmCC);
        }
    }

    .synopsis-content{
        width: 100%;
        // height: 100%;
        padding: 16px 8px 24px ;
        box-sizing: border-box;
        background: rgba($color: #DFEBF7, $alpha: 0.39);
        border-radius: 8px;


        font-size: 14px;

        font-weight: 400;
        // line-height: 21px;
        color: #5B616C;

        margin-bottom: 24px;
    }

}







//最近推荐
.nearest-recommend{
    width: 100%;
    height: 100%;
    background: #fff;
    box-sizing: border-box;
    // overflow: hidden;
    // overflow-x: auto;
    padding-left: 18px;
    padding-top: 16px;
    padding-bottom: 16px;

    .nearest-title{

        font-size: 18px;

        font-weight: 500;
        // line-height: 31px;
        color: #34353C;
        margin-bottom: 16px;
    }

    .nearest-content{
        height: 100%;
        overflow-x: auto;

         .nearest-item{
             width: 102px;
             float: left;
             margin-right: 14px;
              .choiceness-img{
                    width: 100%;
                    height: 102px;
                    position: relative;
                    border-radius: 6px;
                    .item-img{
                        width: 100%;
                        height: 100%;
                        border-radius: 6px;
                    }

                    .choiceness-title{
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 102px;
                        height: 25px;
                        line-height: 25px;
                        background: linear-gradient(180deg, rgba(44, 44, 44, 0) 0%, #000000 100%);
                        opacity: 0.69;
                        border-radius: 0px 0px 6px 6px;
                        .IitenIn{
                        // display: block;

                        font-size: 10px;

                        font-weight: 400;
                        // line-height: 18px;
                        color: #FFFFFF;
                        margin-left: 6px;
                        vertical-align: text-bottom;
                    }

                        .play-icon{
                        // position: absolute;
                        // bottom: 8px;
                        // right: 8px;
                        // width: 26px;
                        // height: 26px;
                        width: 15px;
                        height: 15px;
                        padding-top: 6px;
                    }
                    }

                }
                h3{
                    font-size: 16px;
                    height: 22px;

                    font-size: 14px;

                    font-weight: 400;
                    // line-height: 18px;
                    color: #333333;
                    margin-bottom: 2px;
                    margin-top: 4px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
                .introduce{
                    width: 100%;
                    font-size: 12px;

                    font-weight: 400;
                    color: #7A7A7A;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-bottom: 4px;

                }
                .parameter{
                    font-size: 10px;

                    font-weight: 400;
                    color: #999999;
                    // .IitenIn{
                    //     // display: block;
                    //     margin-right: 18px;
                    // }
                    .update{
                        // display: block;

                    }
                }

        }
    }



}


.heartIcon {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('data:image/png;base64,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');
    &.active {
        display: inline-block;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFPklEQVR4Xu2aXWgcVRTH/2e2jbUGFXxo/YjWmVR8EV+qTxZLEloaLdQKMbtJCFbUqgWRilRUCBYUqVrwo0qLNg1pJvqgKAhaRWyFihYpFEEtu9lEkzW0tdhYN8bszJGdnWR3NpvOvTOzH2VnXjbsnPM/5/zm3HtmdkKo84PqvH6EAMIOqHMC4RKo8wYIN8FwCYRLoM4JhEugzhsgnAKBLQE+sOpqLItsAJMK8LUAlgH0B5gnEMEx6kz8JNptrGtNAK8FKzeBeCUYy0E4DVAKpnGcupI/iGq52fkGwEOr7gZFdgLUCmDpogEZKZB5EJH0HuqYPFNsZwG8bMljAD8IotUuiU+A+RAwvZtiqbNuRV7svGcArDddB27YD6J2uQQ4DcZbOJV4jvqQ4Q/RAEPtA5QnAFwpp4UpgHchmniNAJb0tcw9AWBdXQPQpwBlW93r8SUMcwcUeh9Ea7yK5Pz4E6TP99BDZ/+W1ZEGwIPqHYjQNwAtdwbj3DWgrKT1h/2Z/SAJ1LYvc4GPrXVxnRNoTN9Fm1JpGQhSAPigeiMa6HuAVjqCWMm6SRUCkkmxlO1ctxfH5I8pmtgio+6WtbNOXf0CUNbnv5y70jIhCxpE0q2k+YIUjEcomtwvKi0MgA+p7VCUz+aFPda+IDFLx4fYgu7jSUSmVlPHmQsiEMQB6NpX9qgT0RWw8VF0aYr5b01+lLoS+wSSEJsC/NH112Dm8kkAS0RExW2CgpDdXxwb7WGKxjeI5CHUAaw39wAYyLe/yKYnEj5AGyfLDBrTV4lMBEEA2vMA7appAPOj184yY9xKPclf3RCLARhufhuMx3P3HDV49UvlxZl1FBs9EgwAXesHqDcnFtS6dUtN8vyCC2PeS9GR/NRaRE6sA4a0V0D0zCW1BAzzTuoeOe6GURTADhC9ekkBaJhuovsnxoMBoN+8FogcrW0AjlJTiMZvEHlCFOuAPii4RUuBaEVtboRF+xKbeyk2kn28dj2EAFhbn140Cl2lK2lQCIANUOY26hz7WSQDcQADK67A0sYEYHdBTQyEEhOJcYBi8a0ixWdthAFY9Q5pvSDqFxWvgt05GNO3U7f75jeXmxQAG4JzJFahytIh+V9EqIU64t/JpCQNwN4P9gH0sCNQde8Q/wPMLSI3PsVwPAGwIbwD0DYZ2mWynQHzZoolPvei7xmADeFNgLZ7CRyMD0/DMDdTd/KwVz1fAHIQ1NcB5SmvCXj3s35e30SxxNfeNSSnwGKBWNd2A/S0n0SkfBn/AJl7RJ723HR9d8BcAB5SXwYpO90CBnD+AmC0UzT5bQBacvcBbgFZ114E6AU3Ox/np4DZjRQdO+ZDw+EaWAfkO6H5WRBeCirBvA6fh2muD/LFaFY7cADWxjikOR+f/dJg/guMNupK/OhXqti/LAAsCMPqk2DaI/DKyK2mc8BsG0XHTrgZejlfNgA5CNp2MN7wDIHxJ2C0UCx50ktxIj5lBWDfJ2wDaK80BObTUNAq848VIgVXbAkUBmJdyz43vAuQIpYkT4IyLaLP9GKapa3K3gHz00FXtwLKe440Sr8XTIEzrRQb/cVPYaK+FQOQWw7NPWDuBy3SCYxxKGYrdY6cEi3Ar11FAVgQBtUYIjQAUMSZPP8Oc3Yddf024rcoGf+KA8h1gvYAQIMFL1sTQKaNoqOjMskHYVsVADaE+wD6AMyjMKmFuuOuv+EHUXBVpsBiifOwthEzMyepd3yiHMWJaFatA0SSq4RNCKASlGs5RtgBtXx1KpFb2AGVoFzLMcIOqOWrU4nc/gev3Z9Qm6CY7gAAAABJRU5ErkJggg==');
    }
}

.heartTitle{

        font-size: 12px;

        font-weight: 400;
        // line-height: 20px;
        color: #8994A9;
        // letter-spacing: 0.2800000011920929px;
        // margin-left: 6px;
    &.active{

        font-size: 12px;

        font-weight: 400;
        // line-height: 20px;
        color: #FFA724;
        // letter-spacing: 0.2800000011920929px;
        margin-left: 0px;
    }

}

.synopsisIcon{
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAEqElEQVR4Xu1aX2ibVRT/nfulNS15GK7ixCkb+rC5+SAqTBhYfHEgA8W5JLMP9mkZTafVadpV8JOJTbVqXROHMFhBaJpsDz70QUFwoA8Kexg4qaAPG1boQwTBsUaa3CP3+/JlSWmX+6V/NMm9b8l37rnn/M459++P0OaN2tx/GABMBrQ5AqYE2jwBzCRoSsCUQJsjYEqgzRPA/yrw8bnc/f8U+YAQ2O8HPAYvoiQWOjtw9fUTR/9Yq69tXwh2bu9+3CI8DOadEBTQHYcZeQl55XQ8+qNuH18lkEzPHgdjkkBB3QFWk2PgezDeGx4Mf+19tydmerruss4woY+A0Hr0Azy3VJD99qlj+Xp6tAFIns09R4LnGPCfNmUrmBkgNSSDXC3nl/LzJ4J3P/IsCTkNUI/60xmj0YEYYHL6f5kYDL+wYQCMp7LfMfNBIgLfdqCe/prvqp9qrvOuh+VsOEBAwPleDgk5XvhSX7FLAa3sLJb40dFXI9fupEV7iGQq+7dKTc95IkyUSvJnPRMpJCzax8y9BNrjRrmSBR4WFVUM3CTGNwBdkVxac76oHZtCQtAbDN7l4OgGKjocj8xuCADjqawbPrctJuLh+/Scvy1l23agu2fvcQkkAQ6pTPCiVU4IJXwJcnkocbJvwa/+ZCp7hoC3PV1Syv6Rk9HpzQDgeiIe3u3XQE/+/bOZI5YQF73fVdnw1VJ+/rBt28VGdI+ns++AYf/vAVDOJdPZL0iiz5sOGCgWirfusYf6/6p2/qVcznpqAZ06gCx3yFEQjTYFAGNTmZggca48L6oJ72oiHn6s2tHkZO5BEeD9AAsdAABEGXSsWQDoFSS+9QBg4unheKS/2tGxqUyvReRnT9BqAMw8Y5Ho1oy+EjMAtFgJmAwwJWDmADMJmlXALINmH6CPgNkImY1Qax2GzE6wdXeCycmZgxSw1EWrd3+3ynG4hTNAPYB0be/+FYSdapInotfeGjj6ae19QAsDoBwd+ySzSwSsl9XN72qXl2NTLQ5AveXdAGAywJRA6y6D9erfmSQnZ5+0ArhXR7Ys0zxnAR2nbNvu7Nr20G4WHVrP8UQUAyHWFO8COgD4lWmqpzG/zunIbxkADC4E0LHnVPzFGzqGbYWMennu6tmbYeCIR67Y6Nfh31lxdtx9q1/ugosBYxECE4mB8EdrgZJMXdoHLp4H6AkiaPODPH3O2UJZR0AJfPh0PDJ3pwD4IEjkLhDzK0pxwwyR8sEHzKmlP38ZWvkM/sFnuael5DlihBpBuJprwISbheVbD6x8bV4JhjYADokpaP0Exo5GjKuJkMPewG/EPA2iBSYOkqRDIDxfkWuQhlPpTxwbHoh8Xq/8tAFQiux0bkcQ/CExDgFwCE1+WnXmVKJVUcBwOVTr4iAVCLhWAt6tl/resL4A8OPsSln11C2ILiomWA1ZqswGc8BhAlOFOzS5lJ9/s1G2iK6tWwaAl0FdzAkGx9bkGjJ+kJAjI4PRy7pOrEduSwHwDLXTuVAny14LDnNsGwkqyJK8gRIujwxFr6/HIb99/xMA/Bq5mfIGgM1Etxl0mwxohihtpo0mAzYT3WbQ3fYZ8C9xJqNuu3682gAAAABJRU5ErkJggg==)
}





.commentIcon {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDI2IDI2Ij4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgZmlsbDogI2FhYTsNCiAgICAgICAgb3BhY2l0eTogMDsNCiAgICAgIH0NCg0KICAgICAgLmNscy0yIHsNCiAgICAgICAgZmlsbDogbm9uZTsNCiAgICAgICAgc3Ryb2tlOiAjYWFhOw0KICAgICAgICBzdHJva2UtbGluZWNhcDogcm91bmQ7DQogICAgICAgIHN0cm9rZS1saW5lam9pbjogcm91bmQ7DQogICAgICAgIHN0cm9rZS13aWR0aDogMS44cHg7DQogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsNCiAgICAgIH0NCiAgICA8L3N0eWxlPg0KICA8L2RlZnM+DQogIDxnIGlkPSJpY29uX3hpYW5ncWluZ19waW5nbHVuMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4xODMgMCkiPg0KICAgIDxyZWN0IGlkPSLljaDkvY0iIGNsYXNzPSJjbHMtMSIgd2lkdGg9IjI2IiBoZWlnaHQ9IjI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4xODMgMCkiLz4NCiAgICA8cGF0aCBpZD0i5b2i54q257uT5ZCIIiBjbGFzcz0iY2xzLTIiIGQ9Ik0xMi45NjgsNEExMC41OCwxMC41OCwwLDAsMCw1Ljg3Nyw2LjYzNSw4LjM2Nyw4LjM2NywwLDAsMCwzLDEyLjg2MWE4LjM2Nyw4LjM2NywwLDAsMCwyLjg3Nyw2LjIyNSwxMC41OCwxMC41OCwwLDAsMCw3LjA5MSwyLjYzNSwxNi45MjgsMTYuOTI4LDAsMCwwLDQuNDEtLjY5MWwzLjYyOC41OTEtLjYzLTIuODM0YTguMzA2LDguMzA2LDAsMCwwLDIuNTYxLTUuOTI3LDguMzY3LDguMzY3LDAsMCwwLTIuODc3LTYuMjI1QTEwLjU4LDEwLjU4LDAsMCwwLDEyLjk2OCw0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41MzkgMC4xNCkiLz4NCiAgPC9nPg0KPC9zdmc+DQo=');
}
.playlistIcon {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
     background-image: url('data:image/svg+xml;base64,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');
}
.prevButton {
    background-repeat: no-repeat;
    background-size: 100% 100%;
     background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADAElEQVRoQ+2YzUtUYRTGn+ed0RnNj1yIFoPOx92I0McqWuomdFMUCTMtpKVIhX0RQZJRkKgQVIQQ+IFzR9wULfoTiv6HuVEkJIRCbZpA54RjmjPo3Ovce+c6MLN933Pe53eec947vESF/1jh+lEF8NrBqgNVB2xWoNpCNguYC5elUB02giOA9AJcA7Ifkcm+4tUvGbP8njsgyfApKL8OoKtA7Cf4Mj0cWP5dDMIUQN5rAfyUUYCDW4lkDs18xP70H7PqmK1LKjoCqKcAavfcm5VJXjHu2APQY+Mg7xYkGWc8fc9M4H7rshRux7pvFuS5ojlEvjFhdNgDSMW+A2zPTyIrjBvHSgGQZLQfSs0CaLUSz3i6aJeYt1BKk70OMktcGCMz4SDq1BSEQwBNz92ONzvHNJE4ACB65ASgdJDdVqq+e4/nAKLHroGcABA4qPjN/Z4BiB5pA9UMwL5ShHvaQrIY64NwzuqgFr1lyjnE/74ZkwCGDzKohwJAdK0bRBLASTstUxhblhmQVGQYoiZBBp0U7/oQ5/6ErQc2r8cLTgsvyxCLHp0C1U23xLvqANrTNVjRVgE0VSaALxPCRnDZTfHuOvArXYtmbRWCRjchXL2FRI89A3mjcgHm246gtmEBUqG30HblJRkdguIUwDqn3XC1hXaLlcXOLog/CfC0kxBlA9gULdOoQWPsCYBbIJUTIGUF+N9SnT2gfx5kyC6EJwA5N2bCRxFQr0F1yQ6EZwA7buixQSg+L/V74TlAzo1kRxSsWQB59qBuOADgzLOKLMGHrDYKwX0Afqsg9gF0bQzEaP6B2YeMfx6zKiLvuk2FzwC5p8SolXj7ANPH69FYPwHi/NaB8gY/eJvXS39alJetDWhpegFuP1fugyLylQkjXAzU9F3ISpVK3SOLkcsQNQ2wZe8c8oBx4/GhBcj5uaCF4JM5gL15QkXewW9c5AA2DjXAznWbiiYA1QuRNQAfmDDeWnHW0xayItBsTxXArEJur1cdcLvCZvmrDphVyO31v9mSLkArQhbBAAAAAElFTkSuQmCC');
    &:disabled {
         background-repeat: no-repeat;
    background-size: 100% 100%;
         background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACh0lEQVRoQ+2Zz2sTURDHvzObNBEKWvASan8km4Og1v4BLa2giFg9hCKG2KP4Dwhee9BDwZM3D6IVNik5iyB4qOAf4Ek8mLbWg17Ei9RCsm8kKZWuP7KbfdndPEiueW92PvOdmX1vlmD4jwz3H0OApBUcKjBUQDMCA5NC8hhpZAs5uHs/sfv1G61CBWEbCABxpmfBfBngYx2nRfagmi/o1u57P4hEAeRlMYPv7nWwdeYvR0kpuLJOle1P3SB8AaQOCy17AaDZA0PyDqnGG7oB1y863f6Xmj0ByDLAx/+/Tnao3HimB+AULoJ5zmNEqbdU2XodBkAEhLq9CJF5CHNXGyRNutl4oAdQs+8CNOo1Ij+o3HjYK4A4k2NgqwRYE0H3UvnjqiZA8Z8G/Az/+VCp5mdgWVehkAnqfHud33P8a6CmByCPihmcVEsgPteL44drEwXoFCpJCcJjYZxPTIFOoVbtRZDMg3wK1YcsdgXk6fQJZLkE8GTYqB/dFyuAbNhnoegaqLdC7dpl4uhCUscImoUlMM/0I+qxKiD1U+NojiyDwxdqYgqIk58C8wpAqX5HPpY2KjX7NkDjUTkfaRvFl/015LL3onQ+WgBrfw2uwQDt/ixV+w6IclGqEOl7QJ5P5ZFOVYwt4nbkjW6jh6lj9IvsaP4be5TwQJh8mPudUiYfpz1qmHqh8UCYfKX0gCR3qTd9rOLYF8C04DkutFqbtLKzGeYI0dNgC9KicuO+3lyoPTUeLVwC8emOIVEfkN56FctoUbmfqbL9RAsgTJSD7olluBvUGZ11spE/D0VXQJw9UNmQ8bqnS5n8gUNHPd/ZqI7xOPYOAeKI8sC20X7AD1OoH1HUsfELuipSQO2DQJ0AAAAASUVORK5CYII=');
    }
}
.nextButton {
     background-repeat: no-repeat;
    background-size: 100% 100%;
     background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAC90lEQVRoQ+2Y30sUURTHv98pSwTptXoIXNf+jP6AIKIXc9ylTUGsIDEoqSDTnspAoSCKQvBhdyOIoocgiQJfi3qwoB+7o5HaQtaSkrq77j3RrGtp287sDrYztPM6c+79fu73nHPvXMLjDz2uH1WASjtYdaDqgMMV+H9SSMINe6BpOgR+kAkwM8SWDy8cLqDjcFsOSNh3FJp2bd1syxB1Du+MAfZBOVZS5gCWABL2NYHaaxA1BecQjEEhwGBsqkwNZpg89G/FN+kFGMqNIyPYxgvcG0sVG9caINJ4CuRAcXGShEgHW4275UJIpPESyJ518Zeox047A7jtH4Kg25YwwTDmF46zc2bB1ve/fSTRxk8At6+NkwT1+I5/B2A6L29BCVI3npcCIVG/FPqeeqxollinUCkO/FKQBtV5vLFf4G4DWKlDeYJM6hBDU9NWbrgTINdNkhC0szV+vxiEiwFyhQHgFuYWu/9W4C4HWFl7s8CpU4+9XO+GNwByqtOQ7Fm0TgwSWO08XgLIF/hjMB2i/nHGTDKXtVGrppN/PwslzQzEn3oV4CfILFR6N7QtXzdmI4v4h0CbRwm76/5HBaMDxM2NAShvJy4NhbgIQcFDm/OjRNUBSzNmsbTchNrNSe+lkEgSmmphy8So97qQyCOksofZNpnw2j6QAqQHevyq93ZikXEoCTBojHvsLCQKlCtYVGfYNrlUqFjdXAMzyGbbGJwY9d7/gMgDZJbaGZr+YtVM3ebAd0B1UTeGrYTn37sIQJ6ZhRow3tsVn2ujlb5WEVEABzAf62UnMqWINwEi/n4QvWvjVB91o7/YWNbXKlHfCUAbLC5IJqGpEA9OjJUqfDWFbuysQ33dZRD7V/547uEzT7LL6dXiiG8XarRXIOoLihOJQvEIg7G5csU7ibN0IGdvwz5AuwOydnUywRxEHWPACDsR4DTWFoAJYd5S8wCAJhAJbEpdZ7P1hZVTgVbxtgGsBqrU+ypApVY+P2/VgaoDDlfA8yn0A7/hnkDbrCYdAAAAAElFTkSuQmCC');
    &.disabled {
         background-repeat: no-repeat;
    background-size: 100% 100%;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACgElEQVRoQ+2ZQWsTURDH/7NJCuIiKIjgzWyEgh48Kii1WNG7NbBEBSHgF/AD5AN49SB4KthQsTn0IkJbK7R41IMYBbObSO1JlGJLjNndkU031WCyb3ezqXmwe9zMm5nfzJu8ebMEyR+S3H8kAP87g0kGkgwMGYFQW4jnThxGRj2G3dYuFTe/DWk7luWBAPjhcRVHj9wA0al9q7ZVxYS1RPnNZiyeRFQiBOASFJzWilDo5D82mH/Asip0p2FGtD/0MjHAfO4MCDd9LbG9gbS5SnnYUT3ip0jB0qYAOreng98iXXsl0ikGKGevAMoloWPEW9huVuje1lehbB8BfpKdgaJc7PnJcdapYCz76RMDzGvXQXQ+oFO/gPZz0htvAsrvi3FZuw+Q2ruOd0ivPThIAM8WV5FqhSpwLudK/Rwl/VPf913ZuDPwxwe3wMleJL1eD5KN8QPoeO0wFGygaqxSCY4fyJgCdF22vyDVXqT84MNvzAE6IL4FLgOA9/duv0eLl+hu/effW0oegL3a2IbDFSqYjS6EZABegQPr+Gi8dAtcQgAv9rb9jm6Zz+QFcDns5mOkDhVHc5At5K7BwYUgh9EQMmsALicA/SLA4Zq5aEkY6RYaOQBXSa8tSFjEXp+UN1aIwJIByHyQsbythMzNnLTttMwXGrmvlPJe6sdwrHJggy1tGgpN9fQilrVGt+tuozfwEY9V5rSzyNDsYBUOw+bXmDBXRGNA36nEI2SgZq+ClMmOHDsfkDFeiHSKAdzh7qRWBEs63O0Ew/0ukFZnpRyv90wOuh84nPYOFT5/j9Y7x7tKuIXiNRe/tgQg/piG05hkIFy84pdOMhB/TMNp/A2bwolAeSLwyQAAAABJRU5ErkJggg==');
    }
}
.playButton {
    width: 76px;
    height: 50px;
    background-image: url('data:image/png;base64,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');
    background-repeat: no-repeat;
}
.pauseButton {
    width: 76px;
    height: 50px;
    background-image: url('data:image/png;base64,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');
    background-repeat: no-repeat;
}
.progress {
    width: 100%;
    /*width: 329px;*/
    height: 1px;
    background: hsla(0, 0%, 82%, 1);
    border-radius: 2px;
    overflow: visible;

    .bar {
        // background: hsla(353, 100%, 61%, 1);
        background: #FFA724;
        border-radius: 2px;
    }
    .point {
        position: absolute;
        z-index: 1;
        height: 6px;
        width: 6px;
        top:-2px;
        background: #FFA724;
        border-radius: 50%;
        // color: white;
        font-size: 8px;
    }

    .bar-timer{
        width: 100%;
        display: flex;
        justify-content: space-between;

        margin-top: 4px;
        font-size: 10px;

        font-weight: 400;
        // line-height: 11px;
        color: #8994A9;
        letter-spacing: 0.2800000011920929px;

    }
}
</style>
